/** Structure portable de l'archive complète de la galerie. */
export const VERSION_FORMAT_EXPORT = 2;
export const FICHIER_LECTURE_EXPORT = 'ouvrir.html';
//# sourceMappingURL=export.js.map